import React from "react";
import "../styles/ads.scss";

const AdsPlaceholder = ({ placement, clientConfig, styleClass, children } : { placement: string, clientConfig: any,styleClass?: string, children?: React.ReactNode
 }) => {
    const adConfig = clientConfig?.clientSiteSettings?.adsConfig?.adPlacements?.find(
        (ad : any) => ad.id === placement
    );
    if (!clientConfig?.clientSiteSettings?.adsConfig?.enabled || !adConfig?.enabled) {
        return null;
    }

    return (
        <div
            className={`ad-container ${styleClass}`}
            data-placement={placement}
            style={{
                width: adConfig.size.width,
                height: adConfig.size.height
            }}
        >
            {/* Ad content will be injected here */}
            <div id={`ad-${placement}`} >{children}</div>
        </div>
    );
};

export default AdsPlaceholder;